document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('custom-quick-add-modal')) {
    class CustomQuickAddModal extends ModalDialog {
      preprocessHTML(productElement) {
        // Add color/gradient classes
        if (productElement.classList) {
          productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith('color-') || classApplied === 'gradient')
              this.modalContent.classList.add(classApplied)
          });
        }
        // Remove unwanted elements
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
        // Prevent duplicated IDs (optional, see quick-add.js for more robust logic)
        // Update image sizes (optional, see quick-add.js for more robust logic)
        // Prevent variant URL switching
        productElement.setAttribute('data-update-url', 'false');
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        // Set a default section or skip this step
        this.dataset.section = 'custom-quick-add';
        document.body.appendChild(this);
        // Do NOT call super.connectedCallback()
      }

      constructor() {
        super();
        if (!this.dataset.section) {
          this.dataset.section = 'custom-quick-add';
        }
        this.modalContent = this.querySelector('.quick-add-modal__content-info');
        this.closeButton = this.querySelector('.quick-add-modal__toggle');
        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => this.hide());
        }
      }

      show(opener) {
        this.openedBy = opener;
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        // Show spinner if present
        var spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            if (productElement) {
              this.preprocessHTML(productElement);
              // Extract and append scripts
              const scripts = productElement.querySelectorAll('script[src]');
              scripts.forEach(script => {
                if (!document.querySelector(`script[src="${script.src}"]`)) {
                  const newScript = document.createElement('script');
                  newScript.src = script.src;
                  newScript.defer = script.defer;
                  document.body.appendChild(newScript);
                }
              });
              // Use HTMLUpdateUtility if available
              if (window.HTMLUpdateUtility && typeof HTMLUpdateUtility.setInnerHTML === 'function') {
                HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
              } else {
                this.modalContent.innerHTML = '';
                this.modalContent.appendChild(productElement);
              }

              // Handle bundle ATC button replacement and view details positioning
              const bundleAtcButton = this.modalContent.querySelector('.bundle-atc');
              const viewDetails = this.modalContent.querySelector('.product__view-details');
              const accordion = this.modalContent.querySelector('.product__accordion.accordion');

              if (bundleAtcButton && viewDetails) {
                // For bundle products: hide ATC button and position view details above accordion
                bundleAtcButton.style.display = 'none';

                if (accordion) {
                  console.log('Moving view details button above product accordion');
                  accordion.insertAdjacentElement('beforebegin', viewDetails);
                }
              } else if (viewDetails && accordion) {
                // For regular products: also position view details above accordion
                console.log('Moving view details button above product accordion');
                accordion.insertAdjacentElement('beforebegin', viewDetails);
              }

              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              if (window.ProductModel) window.ProductModel.loadShopifyXR();
              // Re-initialize media-gallery and product-gallery custom elements
              const galleries = this.modalContent.querySelectorAll('media-gallery, product-gallery');
              galleries.forEach(gallery => {
                // Remove and re-add to force re-initialization
                const parent = gallery.parentNode;
                const next = gallery.nextSibling;
                parent.removeChild(gallery);
                if (next) {
                  parent.insertBefore(gallery, next);
                } else {
                  parent.appendChild(gallery);
                }
                // For product-gallery, call init() if available
                if (gallery.tagName === 'PRODUCT-GALLERY' && typeof gallery.init === 'function') {
                  gallery.init();
                }
              });

              // Initialize bundle functionality if bundle content is present
              if (this.modalContent.querySelector('.bundle-component') && window.initializeQuickAddBundle) {
                console.log('Custom Quick Add: Bundle components found in modal, initializing...');
                window.initializeQuickAddBundle(this);
              } else {
                console.log('Custom Quick Add: No bundle components found or initializeQuickAddBundle not available');
                console.log('Bundle components found:', this.modalContent.querySelectorAll('.bundle-component').length);
                console.log('initializeQuickAddBundle available:', !!window.initializeQuickAddBundle);
              }

              super.show(opener);
            } else {
              this.modalContent.innerHTML = '<p>Product info could not be loaded.</p>';
            }
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            // Hide spinner if present
            var spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      hide() {
        // Clean up bundle instances for this modal
        if (window.bundleInstances) {
          window.bundleInstances.forEach(instance => {
            if (instance && typeof instance.cleanup === 'function') {
              instance.cleanup();
            }
          });
          window.bundleInstances = [];
        }

        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
      }
    }
    customElements.define('custom-quick-add-modal', CustomQuickAddModal);
  }

  // Modal opener for custom quick shop
  document.querySelectorAll('.custom-quick-shop--wrapper').forEach(function(wrapper) {
    wrapper.addEventListener('click', function(e) {
      e.preventDefault();
      var modalSelector = wrapper.getAttribute('data-modal');
      var modal = document.querySelector(modalSelector);
      if (modal && typeof modal.show === 'function') {
        modal.show(wrapper);
      }
    });
  });
})
